import { maxLength, required, TextInput } from "react-admin";
import { Grid } from "@mui/material";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="descriptionBg"
          label="Описание на български"
          fullWidth
          validate={[required(), maxLength(255)]}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="descriptionEn"
          label="Описание на английски"
          fullWidth
          validate={[required(), maxLength(255)]}
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
